import { render, staticRenderFns } from "./Hierarquia.vue?vue&type=template&id=2b96e92f"
import script from "./Hierarquia.vue?vue&type=script&lang=js"
export * from "./Hierarquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports